"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.telemetryKeys = exports.minSecretLength = exports.maxSecretLength = exports.maxDomainPerApiKey = exports.logMessageKeys = void 0;
exports.logMessageKeys = {
    startExecuteDriver: "driver.apiKey.log.startExecuteDriver",
    skipCreateApiKey: "driver.apiKey.log.skipCreateApiKey",
    apiKeyNotFound: "driver.apiKey.log.apiKeyNotFound",
    successCreateApiKey: "driver.apiKey.log.successCreateApiKey",
    failedExecuteDriver: "driver.apiKey.log.failedExecuteDriver",
    skipUpdateApiKey: "driver.apiKey.log.skipUpdateApiKey",
    successUpdateApiKey: "driver.apiKey.log.successUpdateApiKey",
};
exports.maxDomainPerApiKey = 1;
exports.maxSecretLength = 512;
exports.minSecretLength = 10;
exports.telemetryKeys = {
    isCustomAPIKey: "is-custom-api-key",
};
//# sourceMappingURL=constants.js.map